export function createActionGuard() {
  const running = new Map();

  function run(key, action) {
    const stableKey = String(key || 'default');
    if (running.has(stableKey)) return running.get(stableKey);
    const task = Promise.resolve().then(action).finally(() => running.delete(stableKey));
    running.set(stableKey, task);
    return task;
  }

  return {
    run,
    isRunning: key => running.has(String(key || 'default')),
  };
}
